import script from "./PageAction.vue?vue&type=script&setup=true&lang=js"
export * from "./PageAction.vue?vue&type=script&setup=true&lang=js"

import "./PageAction.vue?vue&type=style&index=0&id=0e63fd3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e63fd3a"]])

export default __exports__